var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.16667 13.8333H3.345L11.1067 6.07167L9.92833 4.89334L2.16667 12.655V13.8333ZM15.5 15.5H0.5V11.9642L11.6958 0.768342C11.8521 0.612116 12.064 0.524353 12.285 0.524353C12.506 0.524353 12.7179 0.612116 12.8742 0.768342L15.2317 3.12584C15.3879 3.28211 15.4757 3.49404 15.4757 3.71501C15.4757 3.93598 15.3879 4.1479 15.2317 4.30418L5.7025 13.8333H15.5V15.5ZM11.1067 3.71501L12.285 4.89334L13.4633 3.71501L12.285 2.53667L11.1067 3.71501Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPen);
export default __webpack_public_path__ + "static/media/edit_pen.30b877d04e50e4d242a1ff33f0da1f72.svg";
export { ForwardRef as ReactComponent };